export default {
    methods: {
        formatBigNumber(number, isPercent) {
            let definitelyANumber = !isNaN(number) && number != null ? number : 0;

            if (isPercent) {
                return parseInt(definitelyANumber).toLocaleString() + '%';
            }

            if (definitelyANumber > 1000000 && definitelyANumber < 1000000000) {
                return (definitelyANumber / 1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million
            } else if (definitelyANumber > 1000000000) {
                return (definitelyANumber / 1000000000).toFixed(1) + 'B'; // convert to B for number from > 1 billion
            } else {
                return parseInt(definitelyANumber).toLocaleString();
            }
        }
    }
}